/**
 * Enum representing different types of products.
 *
 * This enum is closely linked with the product type definitions in the backend, which in turn flow from our Kiota client and HubSpot.
 */
export enum ProductType {
  Heatpump = 'Heatpump',
  Battery = 'Battery',
  SolarPanels = 'SolarPanels',
  InsulationGround = 'InsulationGround',
  InsulationFloor = 'InsulationFloor',
  InsulationWall = 'InsulationWall',
  InsulationRoof = 'InsulationRoof',
  InsulationGlass = 'InsulationGlass',
  AddOnEVCharger = 'AddOnEVCharger',
  AddOnEMS = 'AddOnEMS',
  AddOnSolarCarport = 'AddOnSolarCarport',
  AddOnRoofRepair = 'AddOnRoofRepair',
  AddOnHeatpump = 'AddOnHeatpump',
  ExtraCost = 'ExtraCost',
  Watercylinder = 'WaterCylinder',
  Discount = 'Discount',
  AddOnWaterHeater = 'AddOnWaterHeater',
  HeatpumpIndoorUnit = 'HP_indoor_unit',
  AddOnInductionCooking = 'AddOnInductionCooking',
  AddOnParallelCircuit = 'AddOnParallelCircuit',
  InsulationWindowFrameAndGlass = 'InsulationWindowFrameAndGlass',
}
